<div>

  <div class="profile-fix">

    <div class="row" style="margin: 0px;border-radius: 3px; box-shadow:0px 0px 2px 2px #dfdede">
      <div class="col-md-3" style="background: #061430;
      border: 1px solid #061430;
      border-radius: 3px 0px 0px 3px;">
        <div class="flex-1">
          <div class="ht-img">
            <img src="https://www.svgimages.com/svg-image/s5/man-passportsize-silhouette-icon-256x256.png"
              alt="stack photo" class="img">
          </div>

          <div class="ht-t">
            <h2
              style="font-size: 16px;margin-bottom: 0px;line-height: 20px;margin-top: 6px;font-weight: 900;color: #df3e3e;">
              {{CustomerData.Customer_Name}}
            </h2>
            <p style="font-size: 12px;margin-bottom: 6px;color: #fff;">{{CustomerData.Gender}},
              {{CustomerData.Date_Of_Birth}}, {{CustomerData.nationality}}.</p>
          </div>
        </div>
        <!-- <select style="width: 100%;background-color: #ef6c00;;border-radius: 2px;height: 28px;border:none;color:#fff">
          <option>Choose Account</option>
          <option>Home</option>
          <option>Person</option>
          <option>Credit Card</option>
        </select> -->
        <!-- <button style="width: 100%;background-color: #ef6c00;;border-radius: 0px;height: 28px;" mat-icon-button
          [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <p style="font-size:12px;color: #fff;line-height: 10px;"> Choose Account<mat-icon
              style="font-size:15px;position: relative;top:3px">arrow_downward</mat-icon>
          </p>

        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>
            <mat-icon style="font-size:18px;">home</mat-icon>
            <span>123458012582825987</span>
          </button>
          <button mat-menu-item>
            <mat-icon style="font-size:18px;">person</mat-icon>
            <span>153458012582825987</span>
          </button>
          <button mat-menu-item>
            <mat-icon style="font-size:18px;">credit_card</mat-icon>
            <span>985458012582825965</span>
          </button>
        </mat-menu> -->
      </div>

      <div class="col-md-9" style="padding-left: 0px;padding-right: 0px;border-radius: 0px 3px 3px 0px;">
        <table style="width: 100%;height: 96px;padding-right: 0px;background: #EBEBEB !important;"
          class="table_wrapper inpo">
          <!-- style="width: 100%;height: 96px;padding-right: 0px;background:#0b3052 #e3dfe7!important" -->
          <tr style="font-size: 12px; line-height:11px;">
            <th
              style="padding: 10px 10px 0px 10px !important; width:152px; font-size:10px !important; background: none !important; color:#595555 !important;">
              PASSPORT NUMBER</th>
            <th
              style="padding: 10px 10px 0px 10px !important; width:152px; font-size:10px !important; background: none !important; color:#595555 !important;">
              ACCOUNT NUMBER</th>
            <th
              style="padding: 10px 10px 0px 10px !important; width:152px; font-size:10px !important; background: none !important; color:#595555 !important;">
              Fintresle ID</th>
            <th
              style="padding: 10px 10px 0px 10px !important; width:152px; font-size:10px !important;background: none !important; color:#595555 !important;">
              AGREEMENT ID</th>
            <th
              style="padding: 10px 10px 0px 10px !important; width:152px; font-size:10px !important;background: none !important; color:#595555 !important;">
              NO OF ACC</th>
            <th
              style="border-right: none !important;padding: 10px 10px 0px 10px !important; width:152px; font-size:10px !important;background: none !important; color:#595555 !important;">
              PRODUCT</th>
          </tr>
          <tr style="font-size: 12px; line-height:14px;">
            <td
              style="padding: 10px;font-size:12px !important;font-weight:bold;color:#595555 !important; background: none !important;">
              {{CustomerData.passport_no}}</td>
            <td
              style="padding: 10px;font-size:12px !important;font-weight:bold;color:#595555 !important; background: none !important;">
              {{CustomerData.acc_no}}</td>
            <td
              style="padding: 10px;font-size:12px !important;font-weight:bold;color:#595555 !important; background: none !important;">
              {{CustomerData.fint_id}}</td>
            <td
              style="padding: 10px;font-size:12px !important;font-weight:bold;color:#595555 !important; background: none !important;">
              {{CustomerData.AGREEMENT_ID}}</td>
            <td
              style="padding: 10px;font-size:12px !important;font-weight:bold;color:#595555 !important; background: none !important;">
              {{CustomerData.NO_OF_ACC}}</td>
            <!-- <td style="padding: 10px;font-size:12px !important;font-weight:bold;color:#595555 !important; background: none !important;"><span *ngIf="LinkedAccounts.length != 0">{{LinkedAccounts.length}} </span>   <span *ngIf="LinkedAccounts.length == 0">0</span></td> -->
            <td
              style="padding: 10px;font-size:12px !important;font-weight:bold;color:#595555 !important; background: none !important;border-right: none !important;">
              {{CustomerData.product_name}}</td>
          </tr>
          <tr style="line-height:11px;">
            <th
              style="padding: 10px 10px 0px 10px !important;font-size:10px !important;background: none !important; color:#595555 !important;">
              PRINCIPLE AMT
            </th>

            <th
              style="padding: 10px 10px 0px 10px !important;font-size:10px !important;background: none !important; color:#595555 !important;">
              INTEREST & OTHER AMT
            </th>
            <th
              style="padding: 10px 10px 0px 10px !important;font-size:10px !important;background: none !important; color:#595555 !important;">
              TOTAL OUTSTANDING AMT</th>
            <th
              style="padding: 10px 10px 0px 10px !important;font-size:10px !important;background: none !important; color:#595555 !important;">
              MINIMUM PAYMENT AMT.</th>
            <th
              style="padding: 10px 10px 0px 10px !important;font-size:10px !important;background: none !important; color:#595555 !important;">
              TOTAL OVERDUE AMT.
            </th>
            <th
              style="border-right: none !important;padding: 10px 10px 0px 10px !important;font-size:10px !important;background: none !important; color:#595555 !important;">
              LEGAL STATUS
            </th>
            <th
              style="border-right: none !important;padding: 10px 10px 0px 10px !important;font-size:10px !important;background: none !important; color:#595555 !important;">
              Action
            </th>

          </tr>
          <tr style="line-height:14px;">
            <td
              style="padding: 0px 10px 10px 10px !important;font-size:12px !important;font-weight:bold;color:#595555 !important;background: none !important;">
              {{CustomerData.PRINCIPLE_AMT | number: '2.'}}</td>
            <td
              style="padding: 0px 10px 10px 10px !important;font-size:12px !important;font-weight:bold;color:#595555 !important;background: none !important;">
              {{CustomerData.INT_AMT | number: '2.'}}</td>
            <td
              style="padding: 0px 10px 10px 10px !important;font-size:12px !important;font-weight:bold;color:#595555 !important;background: none !important;">
              {{CustomerData.total_out_standing | number: '2.' }}</td>
            <td
              style="padding: 0px 10px 10px 10px !important;font-size:12px !important;font-weight:bold;color:#595555 !important;background: none !important;">
              {{CustomerData.MINIMUM_PAYMNET_AMOUNT | number: '2.'}}</td>
            <td
              style="padding: 0px 10px 10px 10px !important;font-size:12px !important;font-weight:bold;color:#595555 !important;background: none !important;border-right: none !important;">
              {{CustomerData.TOTAL_OVERDUE_AMT | number: '2.'}}</td>
            <td
              style="padding: 0px 10px 10px 10px !important;font-size:12px !important;font-weight:bold;color:#595555 !important;background: none !important;border-right: none !important;">
              {{CustomerData.LEGAL_STATUS}}</td>
            <td
              style="padding: 0px 10px 10px 10px !important;font-size:12px !important;font-weight:bold;color:#595555 !important;background: none !important;border-right: none !important;">
              <a class="btn btn-sm btn-dark" [routerLink]="['/admin_panel/portfilo_recordlist']"
                routerLinkActive="router-link-active">Back</a></td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div class="tab-info" style="margin-top: 125px;">
    <mat-tab-group>
      <mat-tab label="Account">

        <!-- <div class="row" style="margin:5px 0px; background:#e8e8e8;"> -->
        <div class="row" style="margin:5px 0px; background:#f2efefd1;">
          <div class="col-md-12" style="background:#fff; padding:10px 10px;margin:10px 0px;">
            <h4 class="title" style="margin-top: 0px !important;">Customer 360&#176; Overview
            </h4>
            <h4 class="title" style="margin-top: 15px; text-align: right;margin-top: -29px !important;">
              <!-- <span class="inner-a"><a >Assistance Request</a></span>
              <span class="inner-a"><a >Account Transfer Request</a></span>
              <span class="inner-a"><a >Retain Account</a></span> -->
              <!-- <span class="inner-a"><a (click)="openworklist()">Set Remainder</a></span> -->
            </h4>
          </div>
          <div class="col-md-12">
            <div class="col-md-12 card-box"
              style="background: white; border-radius: 3px;  height: 400px;overflow-y: scroll;overflow-x: hidden;">
              <div class="row">
                <div class="col-md-12">
                  <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">Account
                    Information</h2>
                </div>
                <!-- <div class="col-md-1">
                  <span><i class="fa fa-plus-circle" style="font-size:11px !important;color:#ef6c00"
                      (click)="showPositionDialog()"></i></span>
                </div> -->
              </div>
              <!-- <hr> -->

              <div class="row">
                <ng-container class="col-md-10" *ngFor="let item of dataList">
                  <div class="col-md-2 col-sm-2 col-lg-2">
                    <span class="labels" *ngIf="item.column == 'finterstal_id'">
                      CUID ID
                    </span>
                    <span class="labels" *ngIf="item.column !== 'finterstal_id'">
                      {{item.column}}
                    </span>
                  </div>
                  <div class="col-md-3 col-sm-3 col-lg-3 values">
                    <p data-title="{{item.row}}">: {{item.row}}</p>
                  </div>

                </ng-container>

                <!-- <ng-container *ngFor="let item of ContectDetails">
                  <div class="col-md-2 col-sm-2 col-lg-2">
                   <span class="labels" *ngIf="item.column == 'finterstal_id'">
                    CUID ID
                   </span>
                   <span class="labels" *ngIf="item.column !== 'finterstal_id'">
                    {{item.column}}
                   </span>
                  </div>
                  <div  class="col-md-3 col-sm-3 col-lg-3 values">
                    <p data-title="{{item.row}}">: {{item.row}}</p>
                  </div>
                </ng-container> -->
                <!-- <ng-container  class="col-md-2 mr-5"   *ngFor="let item of ContectDetails">
                  <div class="row" >

                    <div class=" labelspopup">
                      Mobile Number
                    </div>
                    <div class="col-md-3valuepopup">
                      : {{item.mobile_Number}}
                    </div>


                  </div>
                </ng-container> -->
              </div>

            </div>

          </div>


          <div class="container-fluid" style="margin-bottom: 10px;">
            <div class="row">
              <div class="col-12">
                <p style="color: black; font-size: 16px;">Contact list</p>
              </div>
              <div class="col-12">
                <div class="card" style="padding:10px;">
                  <table class="table table-bordered table-sm" id="collapse">
                    <thead>
                      <tr>
                        <td>S.No</td>
                        <!-- <td>home_Number</td> -->
                        <td>mobile_Number</td>
                        <!-- <td>office_Number</td> -->

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of ContectDetails; let i = index;">
                        <td>{{i+1}}</td>
                        <!-- <td>{{item.home_Number}}</td> -->
                        <td>{{item.mobile_Number}}</td>
                        <!-- <td>{{item.office_Number}}</td> -->
                        <td> <button class="btn btn-danger" (click)="clearContectdetail(item._id)">Delete</button>
                          <button class="btn btn-success ml-5" (click)="showContactDetails($event,item)">
                            Edit
                          </button>

                          <!-- <button (click)="editContactDetails(item.id)">Edit</button> -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="container-fluid" style="margin-bottom: 10px;">
            <div class="row">
              <div class="col-12">
                <p style="color: black; font-size: 16px;">CIF / CID</p>
              </div>
              <div class="col-12">
                <div class="card" style="padding:10px;">
                  <table class="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <td>S.No</td>
                        <td>BANK NAME</td>
                        <td>PORTFOLIO NAME</td>
                        <td>CUID ID</td>
                        <td>CIF</td>
                        <td>CID</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of CIDCIFlist; let i = index;">
                        <td>{{i+1}}</td>
                        <td>
                          <select [(ngModel)]="item.Bank_id" class="form-control" disabled>
                            <option *ngFor="let item of origianl_bank_list" [value]="item._id">{{item.bank_name}}
                            </option>
                          </select>
                        </td>
                        <td>
                          <select [(ngModel)]="item.Portfolio_id" class="form-control" disabled>
                            <option *ngFor="let item of original_portfolio_list" [value]="item._id">
                              {{item.portfolio_type}}</option>
                          </select>
                        </td>
                        <td>{{item.CUSTOMER_ID}}</td>
                        <td>{{item.CIF}}</td>
                        <td>{{item.CID}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!-- Follow up details -->
          <div class="col-md-12">
            <div class="col-md-12 card-box" style="background: white;
     border-radius: 3px;  height: 260px;overflow-y: scroll;overflow-x: hidden;">
              <div class="row">
                <div class="col-md-12">
                  <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">Follow
                    Up Details</h2>
                </div>
              </div>
              <!-- <hr> -->
              <ng-container *ngIf="FollowUpList.length == 0">
                <p>No Previous FollowUp on this User account</p>
              </ng-container>
              <ng-container *ngIf="FollowUpList.length != 0">
                <div class="row" *ngFor="let item of FollowUpList | slice:FollowUpList.length - 1">

                  <div class="col-md-2 labels">
                    Action to Take
                  </div>
                  <div class="col-md-2 values">
                    : {{item.actiontotake}} </div>
                  <div class="col-md-2 labels">
                    Bank Code
                  </div>
                  <div class="col-md-2 values">
                    : {{item.bcode}} </div>
                  <div class="col-md-2 labels">
                    Customer ID
                  </div>
                  <div class="col-md-2 values">
                    : {{item.customer_id}}
                  </div>
                  <div class="col-md-2 labels">
                    Follow Up Date
                  </div>
                  <div class="col-md-2 values">
                    : {{item.fdate }}
                  </div>
                  <div class="col-md-2 labels">
                    Field Visit Territory
                  </div>
                  <div class="col-md-2 values">
                    : {{item.territory}}
                  </div>
                  <div class="col-md-2 labels">
                    Status
                  </div>
                  <div class="col-md-2 values">
                    : {{item.mstatus}}
                  </div>
                  <div class="col-md-2 labels">
                    Sub Status
                  </div>
                  <div class="col-md-2 values">
                    : {{item.substatus}}
                  </div>

                  <!-- <div class="col-md-2 labels">
                    Tracing Link
                  </div>
                  <div class="col-md-2 values">
                    <ng-container *ngFor="let item of item.tracinglink">
                      <p>Link: {{item.link}} --- Tool: {{item.Tool}}</p>
                    </ng-container>
                  </div> -->
                  <div class="col-md-2 labels">
                    Agent Name
                  </div>
                  <div class="col-md-2 values">
                    <!-- : {{item.createdby.name}} -->
                  </div>
                  <div class="col-md-2 labels">
                    Log Date
                  </div>
                  <div class="col-md-2 values">
                    : {{item.log_date}}
                  </div>
                  <!-- promised details -->
                  <div class="col-md-2 labels">
                    Log Type
                  </div>
                  <div class="col-md-2 values">
                    : {{item.log_type}}
                  </div>
                  <div class="col-md-2 labels">
                    PTP Amount
                  </div>
                  <div class="col-md-2 values">
                    : {{item.ptp_amount | number: '2.'}} </div>
                  <div class="col-md-2 labels">
                    PTP Date
                  </div>
                  <div class="col-md-2 values">
                    : {{item.ptp_status | date:'yyyy-MM-dd':'UTC'}}
                  </div>
                  <div class="col-md-2 labels">
                    Remarks
                  </div>
                  <div class="col-md-2 values">
                    <span data-title="{{item.remarks}}">: {{item.remarks}}</span>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>


          <!-- Asset Details -->
          <div class="col-md-12">
            <div>
            </div>
          </div>
        </div>


      </mat-tab>
      <mat-tab label="Customer Add Info">

        <!-- <div class="row" style="margin:5px 0px; background:#e8e8e8;"> -->
        <div class="row" style="margin:5px 0px; background:#f2efefd1;">
          <div class="col-md-12" style="background:#fff; padding:10px 10px;margin:10px 0px;">
            <h4 class="title" style="margin-top: 0px !important;">Customer 360&#176; Overview
            </h4>
            <!-- <h4 class="title" style="margin-top: 15px; text-align: right;margin-top: -29px !important;">
              <span class="inner-a"><a (click)="openworklist()">Go to your Worklist</a></span>
              <span class="inner-a"><a (click)="show13()">Customer Level Exposure</a></span>
              <span class="inner-a"><a (click)="openworklist()">Currency Convertor</a></span>
              <span class="inner-a"><a (click)="openworklist()">Active Workflow Status</a></span>
            </h4> -->
          </div>


          <div class="col-md-12">
            <div class="col-md-12 card-box"
              style="background: white; border-radius: 3px;  height: 400px;overflow-y: scroll;overflow-x: hidden;">
              <div class="row">
                <div class="col-md-12">
                  <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">
                    Customer Additional Information</h2>
                </div>
                <!-- <div class="col-md-1">
                  <span><i class="fa fa-plus-circle" style="font-size:11px !important;color:#ef6c00"
                      (click)="showPositionDialog()"></i></span>
                </div> -->
              </div>
              <!-- <hr> -->

              <div class="row">
                <ng-container *ngFor="let item of dataList1 ; let i = index;">
                  <div class="col-md-2 col-sm-2 col-lg-2">
                    <span class="labels">
                      {{item.column}}
                    </span>
                  </div>
                  <div class="col-md-2 col-sm-2 col-lg-2 values">
                    <span data-title="{{item.row}}">: {{item.row}}</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>


        </div>
      </mat-tab>
      <mat-tab label="FollowUp">
        <div class="row">
          <div class="col-md-12" style="background:#fff; padding:10px 10px;margin:10px;">
            <h4 class="title" style="margin-top: 0px !important;">FollowUp Overview</h4>

          </div>
          <div class="col-md-12">
            <div class="card-box"
              style="background: white; border-radius: 3px;  height: 260px;overflow-y: scroll;overflow-x: hidden;">
              <div class="row">
                <div class="col-md-12">
                  <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">
                    FollowUp Details</h2>
                </div>
              </div>
              <!-- <hr> -->
              <ng-container *ngIf="FollowUpList.length == 0">
                <p>No Previous FollowUp on this User account</p>
              </ng-container>
              <ng-container *ngIf="FollowUpList.length != 0">
                <div class="row" *ngFor="let item of FollowUpList | slice:FollowUpList.length - 1">

                  <div class="col-md-2 labels">
                    Action to Take
                  </div>
                  <div class="col-md-2 values">
                    : {{item.actiontotake}} </div>
                  <div class="col-md-2 labels">
                    Bank Code
                  </div>
                  <div class="col-md-2 values">
                    : {{item.bcode}} </div>
                  <div class="col-md-2 labels">
                    Customer ID
                  </div>
                  <div class="col-md-2 values">
                    : {{item.customer_id}}
                  </div>
                  <div class="col-md-2 labels">
                    Follow Up Date
                  </div>
                  <div class="col-md-2 values">
                    : {{item.fdate}}
                  </div>
                  <div class="col-md-2 labels">
                    Field Visit Territory
                  </div>
                  <div class="col-md-2 values">
                    : {{item.territory}}
                  </div>
                  <div class="col-md-2 labels">
                    Status
                  </div>
                  <div class="col-md-2 values">
                    : {{item.mstatus}}
                  </div>
                  <div class="col-md-2 labels">
                    Sub Status
                  </div>
                  <div class="col-md-2 values">
                    : {{item.substatus}}
                  </div>
                  <div class="col-md-2 labels">
                    Tracing Tool
                  </div>
                  <div class="col-md-2 values">
                    : {{item.tracingtool}}
                  </div>
                  <!-- <div class="col-md-2 labels">
                    Tracing Link
                  </div>
                  <div class="col-md-2 values">
                    <ng-container *ngFor="let item of item.tracinglink">
                      <p>Link: {{item.link}} --- Tool: {{item.Tool}}</p>
                    </ng-container>
                  </div> -->
                  <div class="col-md-2 labels">
                    Agent Name
                  </div>
                  <div class="col-md-2 values">
                    <!-- : {{item.createdby.name}} -->
                  </div>
                  <div class="col-md-2 labels">
                    Log Date
                  </div>
                  <div class="col-md-2 values">
                    : {{item.log_date}}
                  </div>
                  <!-- promised details -->
                  <div class="col-md-2 labels">
                    Log Type
                  </div>
                  <div class="col-md-2 values">
                    : {{item.log_type}}
                  </div>
                  <div class="col-md-2 labels">
                    PTP Amount
                  </div>
                  <div class="col-md-2 values">
                    : {{item.ptp_amount | number: '2.'}} </div>
                  <div class="col-md-2 labels">
                    PTP Date
                  </div>
                  <div class="col-md-2 values">
                    : {{item.ptp_status | date:'yyyy-MM-dd':'UTC'}}
                  </div>
                  <div class="col-md-2 labels">
                    Remarks
                  </div>
                  <div class="col-md-2 values">
                    <span data-title="{{item.remarks}}">: {{item.remarks}}</span>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-md-12">
            <div class="container-fluid">
              <hr>
              <div class="row" style="text-align: end; margin:10px;">
                <p style="font-size: 14px;"><b>FollowUp List</b></p>
              </div>
              <div class="row">
                <div class="col-12">
                  <ag-grid-angular #agGrid style="width: auto; height: 300px;" class="ag-theme-alpine"
                    [rowData]="FollowUpList" [rowSelection]="'multiple'" [columnDefs]="FollowUpcolumnDefs"
                    [pagination]="true">
                  </ag-grid-angular>
                </div>
              </div>
            </div>
          </div>
        </div>

      </mat-tab>
      <mat-tab label="Settlement">
        <div class="conatiner-fluid">
          <div class="row">
            <div class="col-12" style="background:#fff; padding:10px 10px;margin:10px;">
              <h4 class="title" style="margin-top: 0px !important;">Settlement Overview</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card" style="padding: 10px;">
                <div class="row">
                  <div class="col-md-12">
                    <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">
                      Settlement Details</h2>
                  </div>
                </div>
                <ng-container *ngIf="SettlementList.length == 0">
                  <p>No Previous Settlement on this User account</p>
                </ng-container>
                <ng-container *ngIf="SettlementList.length != 0">
                  <div class="row" *ngFor="let item of SettlementList | slice:SettlementList.length-1">

                    <div class="col-md-2 labels">
                      Settlement type
                    </div>
                    <div class="col-md-2 values">
                      : {{item.settlement_type}} </div>
                    <div class="col-md-2 labels">
                      Account Number
                    </div>
                    <div class="col-md-2 values">
                      : {{item.account_id}} </div>
                    <div class="col-md-2 labels">
                      Current Total
                    </div>
                    <div class="col-md-2 values">
                      : {{item.current_total}}
                    </div>
                    <div class="col-md-2 labels">
                      Payment Date
                    </div>
                    <div class="col-md-2 values">
                      : {{item.payment_date }}
                    </div>
                    <div class="col-md-2 labels">
                      No of Installments
                    </div>
                    <div class="col-md-2 values">
                      : {{item.no_of_installments}}
                    </div>
                    <div class="col-md-2 labels">
                      First Installment
                    </div>
                    <div class="col-md-2 values">
                      : {{item.fst_installment}}
                    </div>
                    <div class="col-md-2 labels">
                      Approval Status
                    </div>
                    <div class="col-md-2 values">
                      : {{item.approval_status}}
                    </div>
                    <div class="col-md-2 labels">
                      Details
                    </div>
                    <div class="col-md-2 values">
                      : {{item.details_notes}}
                    </div>
                    <div class="col-md-2 labels">
                      Documents
                    </div>
                    <div class="col-md-2 values">
                      : {{item.attachment_url}}
                    </div>
                    <div class="col-md-2 labels">
                      Created by
                    </div>
                    <div class="col-md-2 values">
                      : <select [(ngModel)]="item.createdby" class="form-control" disabled>
                        <option *ngFor="let item of original_user_list" [value]="item._id">{{item.name}}</option>
                      </select>
                    </div>
                    <div class="col-md-2 labels">
                      Creator Name
                    </div>
                    <div class="col-md-2 values">
                      : <select [(ngModel)]="item.createdby" class="form-control" disabled>
                        <option *ngFor="let item of original_user_list" [value]="item._id">{{item.name}}</option>
                      </select>
                    </div>

                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="row d-flex justify-content-around" style="text-align: end; margin:10px;">
                <p style="font-size: 16px;"><b>Settlement List</b></p>
                <div class="form-group col-md-4">
                  <select class="form-control" (change)="onTypeChange($event)">
                    <option value="">Choose</option>
                    <option value="OTS">One Time Settlement</option>
                    <option value="MTS">Multi Time Settlement</option>
                  </select>
                </div>
              </div>
              <div class="card">
                <ag-grid-angular #agGrid style="width: auto; height: 300px;" class="ag-theme-alpine"
                  [rowData]="SettlementList | filterBy:userFilter" [rowSelection]="'multiple'"
                  [columnDefs]="SettlementcolumnDefs" [pagination]="true">
                </ag-grid-angular>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Payments">
        <div class="conatiner-fluid">
          <div class="row">
            <div class="col-12" style="background:#fff; padding:10px 10px;margin:10px;">
              <h4 class="title" style="margin-top: 0px !important;">Payments Overview</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card" style="padding: 10px;">
                <div class="row">
                  <div class="col-md-12">
                    <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">
                      Payment Details</h2>
                  </div>
                </div>
                <ng-container *ngIf="PaymentsList.length == 0">
                  <p>No Previous Payment on this User account</p>
                </ng-container>
                <ng-container *ngIf="PaymentsList.length != 0">
                  <div class="row" *ngFor="let item of PaymentsList | slice:PaymentsList.length - 1">

                    <div class="col-md-2 labels">
                      Account Number
                    </div>
                    <div class="col-md-2 values">
                      : {{item.account_id}} </div>
                    <div class="col-md-2 labels">
                      Payment Date
                    </div>
                    <div class="col-md-2 values">
                      : {{item.payment_date}}
                    </div>
                    <div class="col-md-2 labels">
                      Payment Amount
                    </div>
                    <div class="col-md-2 values">
                      : {{item.payment_amount | number: '2.'}}
                    </div>
                    <div class="col-md-2 labels">
                      Due Amount
                    </div>
                    <div class="col-md-2 values">
                      : {{item.due_amount | number: '2.'}}
                    </div>
                    <div class="col-md-2 labels">
                      Paid Date
                    </div>
                    <div class="col-md-2 values">
                      : {{item.paid_date}}
                    </div>
                    <div class="col-md-2 labels">
                      Last Paid Amount
                    </div>
                    <div class="col-md-2 values">
                      : {{item.last_paid_amount | number: '2.'}}
                    </div>
                    <div class="col-md-2 labels">
                      Next Payment Date
                    </div>
                    <div class="col-md-2 values">
                      : {{item.next_payment_date}}
                    </div>
                    <div class="col-md-2 labels">
                      Documents
                    </div>
                    <div class="col-md-2 values">
                      : {{item.attachment_url}}
                    </div>
                    <div class="col-md-2 labels">
                      Created by
                    </div>
                    <div class="col-md-2 values">
                      : {{item.createdby}}
                    </div>
                    <div class="col-md-2 labels">
                      Creator Name
                    </div>
                    <div class="col-md-2 values">
                      : {{item.creator_name}}
                    </div>

                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="row d-flex justify-content-start" style="text-align: end; margin:10px;">
                <p style="font-size: 16px;"><b>Payments List</b></p>

              </div>
              <div class="card">
                <ag-grid-angular #agGrid style="width: auto; height: 300px;" class="ag-theme-alpine"
                  [rowData]="PaymentsList" [rowSelection]="'multiple'" [columnDefs]="PaymentscolumnDefs"
                  [pagination]="true">
                </ag-grid-angular>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Field Visit">
        <div class="conatiner-fluid">
          <div class="row">
            <div class="col-12" style="background:#fff; padding:10px 10px;margin:10px;">
              <h4 class="title" style="margin-top: 0px !important;">Field Visit Overview</h4>
            </div>
          </div>
          <div class="row d-flex justify-content-end">
            <button class="btn btn-sm btn-dark mr-5" (click)="getScard()">View Status Card</button>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card" style="padding: 10px;">
                <div class="row">
                  <div class="col-md-12">
                    <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">Field
                      Visit Details</h2>
                  </div>
                </div>
                <ng-container *ngIf="FieldVisitList.length == 0">
                  <p>No Previous Field Visit on this User account</p>
                </ng-container>
                <ng-container *ngIf="FieldVisitList.length != 0">
                  <div class="row" *ngFor="let item of FieldVisitList | slice:FieldVisitList.length - 1">

                    <div class="col-md-2 labels">
                      Account Number
                    </div>
                    <div class="col-md-2 values">
                      : {{item.account_id}} </div>
                    <div class="col-md-2 labels">
                      Field Visit Territory
                    </div>
                    <div class="col-md-2 values">
                      : {{item.fieldvisitterritory}}
                    </div>
                    <div class="col-md-2 labels">
                      Field Visit Area
                    </div>
                    <div class="col-md-2 values">
                      : {{item.fieldvisitarea}}
                    </div>
                    <div class="col-md-2 labels">
                      First Address
                    </div>
                    <div class="col-md-2 values">
                      : {{item.firstaddress}}
                    </div>
                    <div class="col-md-2 labels">
                      Second Address
                    </div>
                    <div class="col-md-2 values">
                      : {{item.secondaddress}}
                    </div>
                    <div class="col-md-2 labels">
                      Requested Date
                    </div>
                    <div class="col-md-2 values">
                      : {{item.fvrqdate}}
                    </div>
                    <div class="col-md-2 labels">
                      Remarks
                    </div>
                    <div class="col-md-2 values">
                      : {{item.remarks}}
                    </div>
                    <div class="col-md-2 labels">
                      Documents
                    </div>
                    <div class="col-md-2 values">
                      : {{item.attachment_url}}
                    </div>
                    <div class="col-md-2 labels">
                      Status
                    </div>
                    <div class="col-md-2 values">
                      : {{item.status}}
                    </div>
                    <div class="col-md-2 labels">
                      Created by
                    </div>
                    <div class="col-md-2 values">
                      : {{item.createdby}}
                    </div>
                    <div class="col-md-2 labels">
                      Creator Name
                    </div>
                    <div class="col-md-2 values">
                      : {{item.creator_name}}
                    </div>

                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="row d-flex justify-content-start" style="text-align: end; margin:10px;">
                <p style="font-size: 16px;"><b>Field Visit List</b></p>

              </div>
              <div class="card">
                <ag-grid-angular #agGrid style="width: auto; height: 300px;" class="ag-theme-alpine"
                  [rowData]="FieldVisitList" [rowSelection]="'multiple'" [columnDefs]="FieldVisitcolumnDefs"
                  [pagination]="true">
                </ag-grid-angular>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Mapped Accounts">
        <div class="container-fluid">
          <div class="row mt-5">
            <div class="col-12">
              <div class="card">
                <table class="table table-bordered table-sm" style="padding: 10px;">
                  <thead>
                    <tr>
                      <td> Account Number </td>
                      <td> Bank Name </td>
                      <td> Potfolio Name </td>
                      <td> Passport Number </td>
                      <td> CUID ID </td>
                      <td> TOS </td>
                      <td> POS </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of mapped_details">
                      <td> {{item.acc_no}} </td>
                      <td>
                        <select [(ngModel)]="item.bank_id" class="form-control" disabled>
                          <option *ngFor="let item of origianl_bank_list" [value]="item._id">{{item.bank_name}}</option>
                        </select>
                      </td>
                      <td>
                        <select [(ngModel)]="item.porfolio_id" class="form-control" disabled>
                          <option *ngFor="let item of original_portfolio_list" [value]="item._id">
                            {{item.portfolio_type}}</option>
                        </select>
                      </td>
                      <td> {{item.passport_no}} </td>
                      <td> {{item.finterstal_id}}</td>
                      <td> {{item.total_out_standing}} </td>
                      <td>
                      <td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Linked Accounts">
        <div class="container-fluid">
          <div class="row mt-5">
            <div class="col-12">
              <div class="card">
                <table class="table table-bordered table-sm" style="padding: 10px;">
                  <thead>
                    <tr>
                      <td> Account Number </td>
                      <td> Bank Name </td>
                      <td> Potfolio Name </td>
                      <td> Passport Number </td>
                      <td> CUID ID </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of upmapped_details">
                      <td> {{item.acc_no}} </td>
                      <td>
                        <select [(ngModel)]="item.bank_id" class="form-control" disabled>
                          <option *ngFor="let item of origianl_bank_list" [value]="item._id">{{item.bank_name}}</option>
                        </select>
                      </td>

                      <td>
                        <select [(ngModel)]="item.porfolio_id" class="form-control" disabled>
                          <option *ngFor="let item of original_portfolio_list" [value]="item._id">
                            {{item.portfolio_type}}</option>
                        </select>
                      </td>
                      <td> {{item.passport_no}} </td>
                      <td> {{item.finterstal_id}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Reallocation History">
        <div class="container-fluid">
          <div class="row mt-5">
            <div class="col-12">
              <div class="card">
                <table class="table table-bordered table-sm" style="padding: 10px;">
                  <thead>
                    <tr>
                      <!-- <td> Bank ID </td>
                      <td> Portfolio ID</td>
                      <td> Customer ID</td>
                      <td> Account No</td>
                      <td> Passport No </td> -->
                      <td> New User Allocated </td>
                      <td> Old user </td>
                      <td> Old Allocation date </td>
                      <td> New allocation date </td>
                      <td> Updated by</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of Reallocation">
                      <td> {{item.reallocation_to.name}} </td>
                      <td> {{item.assigned_to.name}} </td>
                      <td> {{item.date_of_assign}} </td>
                      <td> {{item.re_allocation_date}} </td>
                      <td> {{item.reallocation_by.name}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Trail Logs">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <mat-icon style="cursor:pointer;text-align: right;width: 100%;margin-bottom: 13px;margin-top: -10px;"
                  mat-button (click)="close()">close</mat-icon>
                <div class="col-md-12">
                  <h4 class="title">Trail Logs </h4>
                </div>

              </div>

              <div class="doc-table">
                <div class="card-box">
                  <table class="table table-bordered table-sm" style="padding: 10px;">
                    <thead>
                      <tr>
                        <td>S.No</td>
                        <td>Type</td>
                        <td>User</td>
                        <td>Remarks</td>
                        <td>Date</td>
                        <td>Action</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style="text-align: start;" *ngFor="let item of RemarksList; let i = index;">
                        <td>{{i+1}}</td>
                        <td>{{item.type}}</td>
                        <td>{{item.User}}</td>
                        <td>{{item.Remarks}}</td>
                        <td>{{item.Date | date: 'medium'}}</td>
                        <td>{{item.Action}}</td>

                        <!-- <td (click)="show()"><a class="link-a">{{item.type}}</a></td>
                          <td>{{item.actiontaken}}</td>
                          <td>{{item.remarks}}</td>
                          <td>{{item.createdby.name}}</td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Documents">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="card" style="padding:10px;">
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <td>S.No</td>
                      <td>Date</td>
                      <td>Link</td>
                      <td>Created By</td>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>


    </mat-tab-group>
  </div>
</div>
<div class="follow">


</div>


<p-dialog header="Account Information" [(visible)]="displayPosition" position="center" [modal]="true"
  [style]="{width: '70vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
  <div class="row">
    <div class="col-md-12">
      <div class="row" style="padding: 0px 0px 6px 10px;">
        <div class="col-md-4">
          <h5 class="form-lable">Account Type:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="Credit Card">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Bank Acc No:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="12345 12345 12345 123">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Loan Acc No:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="12345 12345 12345 123">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Last Payment Date:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="12/12/19">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">POS No:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="123 123 123">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Credit Limit:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="100000">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">CIF No:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="12345 12345 12345 123">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Credit Card No:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="12345 12345 12345 123 ">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Total Outstanding:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="3000000">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Priciple Outstanding:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="200000">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">CID No:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="12345 12345 12345 123">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Status:</h5>
          <input type="text" pInputText disabled=true placeholder="" value="Confirmed">
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-overlayPanel #mailDetails [showCloseIcon]="true" [dismissable]="false"
  [style]="{'position':'absolute','top': '410px'}">
  <ng-template pTemplate>
    <!-- <div class="overlay-contact"> -->
    <div class="col-md-12" style="padding:0px !important;">
      <div class="col-md-12 " style="background: white;
  border-radius: 3px; overflow-y: scroll;overflow-x: hidden; padding:0px !important;">
        <div class="row">
          <div class="col-md-12">
            <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">Mail Details
            </h2>
          </div>
        </div>
        <!-- <hr> -->
        <div class="row" style="padding-bottom:10px;">
          <div class="col-md-2 labelspopup">
            Email 1
          </div>
          <div class="col-md-4 valuepopup">
            <!-- : m@gmail.com <i class="fa fa-envelope" (click)="openworklist2()"
                style="font-size:60px;color: red;"></i> -->
            : m@gmail.com
          </div>
          <div class="col-md-2 labelspopup">
            Email 2
          </div>
          <div class="col-md-4 valuepopup">
            : m@gmail.com
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </ng-template>
</p-overlayPanel>


<p-overlayPanel #contactDetails [showCloseIcon]="true" [dismissable]="false" [style]="{'left':'200px'}">
  <ng-template pTemplate>
    <!-- <div class="overlay-contact"> -->
    <div class="col-md-12" style="padding:0px !important;">
      <div class="col-md-12"
        style="background: white; border-radius: 3px;  height: 200px;overflow-y: scroll;overflow-x: hidden;padding:0px !important;">
        <div class="row">
          <div class="col-md-12">
            <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">Contact
              Details</h2>
          </div>
        </div>
        <form [formGroup]="ContectdetailsForm">
          <div class="row">
            <!-- <div class="col-md-2 labelspopup">
              Home Number
            </div>
            <div class="col-md-2 valuepopup">
            <div class="form-group justify-content">
               <input type="text" placeholder="Home Number" class="form-control"
                    formControlName="home_Number">
            </div>
            </div> -->
            <div class="col-md-2 labelspopup">
              Mobile Number
            </div>
            <div class="col-md-2 valuepopup">
              <div class="form-group justify-content">
                <input type="text" placeholder="Mobile Number" class="form-control" formControlName="mobile_Number"
                  required>
              </div>
            </div>
            <!-- <div class="col-md-2 labelspopup">
              Office Number
            </div>
            <div class="col-md-2 valuepopup">
             <div class="form-group justify-content">
               <input type="text" placeholder="Office Number" class="form-control"
                    formControlName="office_Number">
            </div>
          </div> -->
            <div class="col-md-2 ">
              <button class="btn btn-sm btn-success mr-2" (click)="addContect()">Submit</button>
              <button class="btn btn-sm btn-danger" (click)="close()">Cancel</button>
            </div>
          </div>
        </form>
        <!-- <hr> -->

      </div>
    </div>
    <!-- </div> -->
  </ng-template>
</p-overlayPanel>

<p-overlayPanel #EditPanel [showCloseIcon]="true" [dismissable]="false" [style]="{'left':'200px'}">
  <ng-template pTemplate>
    <!-- <div class="overlay-contact"> -->
    <div class="col-md-12" style="padding:0px !important;">
      <div class="col-md-12"
        style="background: white; border-radius: 3px;  height: 200px;overflow-y: scroll;overflow-x: hidden;padding:0px !important;">
        <div class="row">
          <div class="col-md-12">
            <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">Contact
              Details</h2>
          </div>
        </div>
        <form [formGroup]="ContectdetailsForm">
          <div class="row">

            <div class="col-md-2 labelspopup">
              Mobile Number
            </div>
            <div class="col-md-2 valuepopup">
              <div class="form-group justify-content">
                <input type="text" placeholder="Mobile Number" class="form-control" formControlName="mobile_Number"
                  required>
              </div>
            </div>
            <div class="col-md-2 ">
              <!-- <button class="btn btn-sm btn-success mr-2"(click)="addContect()" >Submit</button> -->
              <button class="btn btn-sm btn-success mr-2" (click)="updateContect()">Update</button>
              <button class="btn btn-sm btn-danger" (click)="close1()">Cancel</button>
            </div>
          </div>
        </form>
        <!-- <hr> -->

      </div>
    </div>
    <!-- </div> -->
  </ng-template>
</p-overlayPanel>


<p-overlayPanel #tracklink [showCloseIcon]="true" [dismissable]="false" [style]="{'left':'250px'}">
  <ng-template pTemplate>
    <!-- <div class="overlay-contact"> -->
    <div class="col-md-12" style="padding:0px !important;">
      <div class="col-md-12"
        style="background: white; border-radius: 3px;  height: 250px;overflow-y: scroll;overflow-x: hidden;padding:0px !important;">
        <div class="row">
          <!-- <div class="col-md-12">
              <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">Activation Details</h2>
            </div> -->
        </div>
        <!-- <hr> -->

        <div class="row" *ngIf="data_hide == false">
          <div class="col-md-12">
            <h3>Invalid</h3>
            <input type="password" placeholder="" class="form-control" [(ngModel)]="enterpassword">
            <br>
            <button class="btn btn-dark btn-sm mt-1" (click)="check_value()">Submit</button>
          </div>
        </div>



        <div *ngIf="data_hide == true">
          <div class="row">
            <div class="col-md-12">
              <h3>Enter Tracking Details</h3>
              <button class="btn btn-dark btn-sm mt-1" style="float: right;" (click)="refresh()"><i
                  class="fa fa-refresh" aria-hidden="true" pTooltip=""></i></button>

              <div class="col-md-12">


                <div class="form-group col-md-4">
                  <label for="">Tracing Tools</label>
                  <select class="form-control" [(ngModel)]="tracingtool" name="tracingtool">
                    <option value="">Choose</option>
                    <ng-container *ngFor="let item of TracingToolsList">
                      <option value="{{item.tracking_name}}">{{item.tracking_name}}</option>
                    </ng-container>
                  </select>
                </div>

                <div class="form-group col-md-4">
                  <label for="">Tracing Link</label>
                  <input type="text" placeholder="tracing link" class="form-control" [(ngModel)]="link"
                    [ngModelOptions]="{standalone: true}">
                  <br>
                  <div style="text-align: end;">
                    <button class="btn btn-dark btn-sm mt-1" (click)="addnewLink()">ADD New Link</button>
                  </div>
                  <br>
                  <ng-container *ngFor="let item of Linklist; let i = index;">
                    <p style="font-size: 12px;">Link {{i+1}}: {{item.link}} - | - {{item.tool}} <button
                        class="btn btn-dark btn-sm mt-1" (click)="delete_track_tool(i)"><i class="fa fa-trash"
                          aria-hidden="true" pTooltip=""></i></button></p>
                  </ng-container>
                </div>


                <div class="form-group col-md-4" *ngIf="edit_view">
                  <label for="">Action</label>
                  <br>
                  <button class="btn btn-dark btn-sm mt-1" (click)="edit_submit()">Sumbit</button>

                </div>

              </div>

            </div>
          </div>
          <div class="row" style="overflow-x:auto;">
            <div class="col-md-12">

              <table>
                <tr>
                  <th>Edit</th>
                  <th>S.no</th>
                  <th>Tracing Link</th>
                  <th>Customer Id</th>
                  <th>Client ID</th>

                  <th>Bucket Id</th>
                  <th>Fintresle Id</th>
                  <th>Passport Id</th>

                  <th>Log Date</th>
                  <th>Log Type</th>
                  <th>Follow up date</th>
                  <th>Main Status</th>
                  <th>Sub Status</th>
                  <th>Remarks</th>
                  <th>Bank Code</th>
                  <th>Action to Taken</th>





                </tr>
                <!-- FollowUpList -->
                <ng-container *ngFor="let item of FollowUpList; let i = index">
                  <tr>
                    <td><button class="btn btn-dark btn-sm mt-1" (click)="edit_track(item)"><i class="fa fa-plus-circle"
                          aria-hidden="true" pTooltip=""></i></button></td>
                    <td>{{i+1}}</td>


                    <td style="font-size: 13px;">
                      <ng-container *ngFor="let track of item.tracinglink; let j = index">
                        ( {{track.tool}} ) - {{track.link}},
                      </ng-container>
                    </td>

                    <td>{{item.customer_id}}</td>
                    <td>{{item.client_id}}</td>

                    <td>{{item.bucket_id}}</td>
                    <td>{{item.finterstal_id}}</td>
                    <td>{{item.passport_no}}</td>


                    <td>{{item.log_date}}</td>
                    <td>{{item.log_type}}</td>
                    <td>{{item.tracingtool}}</td>
                    <td>{{item.mstatus}}</td>
                    <td>{{item.substatus}}</td>
                    <td>{{item.remarks}}</td>
                    <td>{{item.bcode}}</td>
                    <td>{{item.actiontaken}}</td>

                  </tr>
                </ng-container>


              </table>
            </div>
          </div>
        </div>




      </div>
    </div>
    <!-- </div> -->
  </ng-template>
</p-overlayPanel>

<p-overlayPanel #addressDetails [showCloseIcon]="true" [dismissable]="false" [style]="{'left':'250px'}">
  <ng-template pTemplate>
    <!-- <div class="overlay-contact"> -->
    <div class="col-md-12" style="padding:0px !important;">
      <div class="col-md-12"
        style="background: white; border-radius: 3px; overflow-y: scroll;overflow-x: hidden; padding:0px !important;">
        <div class="row">
          <div class="col-md-12">
            <h2 class="title-f" style="color:#21a0f6 !important;font-size:18px; padding:5px 0px 12px 0px;">Address
              Details</h2>
          </div>
        </div>
        <!-- <hr> -->
        <div class="row" style="padding-bottom:10px;">
          <div class="col-md-3 labelspopup">
            Address 1
          </div>
          <div class="col-md-2 valuepopup">
            : {{CustomerData.Address_1}}
          </div>
          <div class="col-md-3 labelspopup">
            Address 2
          </div>
          <div class="col-md-2 valuepopup">
            : {{CustomerData.Address_2}}
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </ng-template>
</p-overlayPanel>

<div class="follow follow-1">
  <div [ngClass]="{'active-i': show === 'show1'}">
    <mat-icon pTooltip="Follow up" (click)="show1()">swap_horiz</mat-icon>
  </div>

  <div style="padding: 6px 9px !important;color: #fff;">
    <i class="fa fa-envelope" aria-hidden="true" pTooltip="" (click)="mailDetails.toggle($event)"></i>


  </div>
  <div style="padding: 6px 9px !important;color: #fff;" (click)="contactDetails.toggle($event)">
    <i class="fa fa-phone" aria-hidden="true" pTooltip=""></i>
  </div>
  <div style="padding: 6px 9px !important;color: #fff;" (click)="addressDetails.toggle($event)">
    <i class="fa fa-address-card" aria-hidden="true" pTooltip=""></i>
  </div>

  <div style="padding: 6px 9px !important;color: #fff;" (click)="tracklink.toggle($event)">
    <img src="../../../../../assets/images/icons.png" style="width: 25px; height: 35px;">
  </div>

</div>